import { Theme, ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import * as React from "react";
import { Theme as ReactUITheme, ThemeContext as ReactUIThemeContext } from "react-ui";

import { darkCandyTheme } from "./CandyTheme/DarkCandyTheme";
import { defaultCandyTheme } from "./CandyTheme/DefaultCandyTheme";
import { diadocCandyTheme } from "./CandyTheme/DiadocCandyTheme";
import { reactUIDarkTheme } from "./ReactUIThemes/ReactUIDarkTheme";
import { reactUIDefaultTheme } from "./ReactUIThemes/ReactUIDefaultTheme";
import { reactUIDiadocTheme } from "./ReactUIThemes/ReactUIDiadocTheme";
import { logisticsCandyTheme } from "./CandyTheme/LogisticsCandyTheme";
import { reactUILogisticsTheme } from "./ReactUIThemes/ReactUILogisticsTheme";

interface ThemesProps {
    theme?: ThemeVariant;
    children: React.ReactNode;
}

export enum ThemeVariant {
    Default = "default",
    Dark = "dark",
    Diadoc = "diadoc",
    Logistics = "logistics",
}

function getCandyTheme(theme?: ThemeVariant): Theme {
    switch (theme) {
        case ThemeVariant.Logistics:
            return logisticsCandyTheme;
        case ThemeVariant.Diadoc:
            return diadocCandyTheme;
        case ThemeVariant.Dark:
            return darkCandyTheme;
        default:
            return defaultCandyTheme;
    }
}

export function getReactUITheme(theme?: ThemeVariant): ReactUITheme {
    switch (theme) {
        case ThemeVariant.Logistics:
            return reactUILogisticsTheme;
        case ThemeVariant.Diadoc:
            return reactUIDiadocTheme;
        case ThemeVariant.Dark:
            return reactUIDarkTheme;
        default:
            return reactUIDefaultTheme;
    }
}

export function ThemeProvider(props: ThemesProps): JSX.Element {
    return (
        <EmotionThemeProvider theme={getCandyTheme(props.theme)}>
            <ReactUIThemeContext.Provider value={getReactUITheme(props.theme)}>
                {props.children}
            </ReactUIThemeContext.Provider>
        </EmotionThemeProvider>
    );
}
